import { render, staticRenderFns } from "./K2CopyInput.vue?vue&type=template&id=ae737abc"
import script from "./K2CopyInput.vue?vue&type=script&lang=js"
export * from "./K2CopyInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports